/// <reference types="vite/client" />
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { router } from './routes';
import { queryClient } from '@favelafood/shared/api/queryClient';
import { initKeycloakAuth } from '@favelafood/shared/auth/keycloak';
import { clearTokens } from '@favelafood/shared/auth/tokens';
import '@favelafood/shared/styles/globals.css';
import '@favelafood/shared/styles/merchant-theme.css';

// Configura o singleton OIDC do tab antes de qualquer ensureKeycloakLogin().
initKeycloakAuth({ clientId: 'favelafood-comerciante' });
// Varre tokens password-grant legados do localStorage uma vez no boot — OIDC
// guarda o token em memória, então essas chaves são só lixo pós-cutover.
clearTokens();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>
);
